import React from 'react';
import { styled } from '@mui/material/styles';
import EuroOutlined from "@mui/icons-material/EuroOutlined";
import { Label } from '../../Label';
const Badge = () => {
    return (React.createElement(LabelContainer, null,
        React.createElement(Label, { backgroundColor: "green100", textColor: "green800", fontWeight: 400, fontSize: "14px", letterSpacing: "normal", textTransform: 'inherit' },
            React.createElement(Icon, { width: 16, height: 16 }),
            "Sans aucuns frais*")));
};
const LabelContainer = styled('div')(({
    width: 'fit-content'
}));
const Icon = styled(EuroOutlined)(({ width, height }) => ({
    color: '#009500',
    height: height,
    width: width,
    marginRight: 4
}));
export default Badge;
